import LT_Pannel from '../images/product/LT-pannel.png';
import Normal_transformer from '../images/product/normal-transformer.png';
import OLTC_transformer from '../images/product/OLTC-transformer.png';
import Servo from '../images/product/servo.png';
import vcd from '../images/product/Vacuum-Circuit-Breakers.png';
import ACB from '../images/product/acb.png';
import rectifier from '../images/product/rectifier.png';
import transformer_500kv from '../images/product/500kv_transformer.png';
import mcc from '../images/product/mcc.png';
import pcc from '../images/product/pcc.png';
import pfc from '../images/product/pfc.png';


export const allProductList = [
    {
      id: "distribution-transformer",
      image: Normal_transformer,
      name: "Distribution Transformer",
      detail: "A Simple Transformer is an electrical device that transfers electrical energy between two or more circuits through electromagnetic induction. It is widely used to step up or step down voltage levels in power distribution systems.",
      subDetail: "Transformers operate on the principle of Faraday's law of electromagnetic induction and are essential for efficient electrical energy transmission and distribution.",
      additionalInfo: "",
      products: [
        {
          p1: "Core",
          brand: "", 
          p2:"The core provides a path for the magnetic flux and is typically made from silicon steel to minimize energy losses.",
        },
        {
          p1: "Primary Winding",
          brand: "", 
          p2:"The primary winding is connected to the input voltage source and generates a magnetic field.",
        },
        {
          p1: "Secondary Winding",
          brand: "", 
          p2:"The secondary winding delivers the transformed voltage to the output load.",
        },
        {
          p1: "Insulation",
          brand: "", 
          p2:"Insulation materials prevent electrical short circuits and enhance safety.",
        },
        {
          p1: "Cooling System",
          brand: "", 
          p2:"Cooling systems, such as oil or air, dissipate heat generated during operation to maintain efficiency.",
        },
        {
          p1: "Tap Changer",
          brand: "", 
          p2:"A tap changer adjusts the turns ratio of the transformer to regulate the output voltage.",
        },
        
      ],
      purchaseReason:
        "Choosing our Simple Transformer guarantees reliability and efficiency. Built using high-quality components from renowned brands like Siemens, Havells, and Schneider, our transformers ensure optimal performance in various applications. We offer customization options to meet your specific voltage and power requirements, making them suitable for both industrial and commercial use. Our dedicated support team is always available to assist you in selecting the right transformer for your needs. Invest in our transformers for a dependable solution to your power distribution challenges.",
        
        variantData: [
         { image: transformer_500kv,
          name: "500 kW transformer",
          detail: "A 500 kW transformer is typically used in industrial applications or large commercial installations where high power needs to be stepped up or stepped down to a usable voltage level. Below are the key specifications and features that would be relevant for a high-quality 500 kW transformer, focusing on materials like copper and steel that optimize performance and minimize losses",
          subDetail: [
            {heading:"Power Rating",
              detail:"500 kW (kilowatts), meaning it can handle up to 500,000 watts of electrical load. It is designed for continuous operation in demanding industrial or commercial environments."
            },
            {heading:"High-Quality Copper Windings",
              detail:"The transformer uses premium-grade copper for windings, which ensures excellent conductivity, minimal energy loss, and long-lasting performance, even under heavy load conditions."
            }, 
            {heading:"Core Material",
              detail:"Built with high-grade silicon steel laminations, which reduce eddy current and hysteresis losses. This ensures high efficiency, optimal magnetic flux, and better heat dissipation."
            }, 
            {heading:"Efficiency",
              detail:"Designed for maximum efficiency (95% to 98%), resulting in minimal energy loss during operation. Its robust construction ensures optimal performance across varying load conditions."
            },
             {heading:"Best for Reduced Losses",
              detail:"The combination of high-quality copper, superior insulation, and premium-grade steel minimizes energy losses, ensuring economic and sustainable power distribution."
            },

          ],
        },
          // { image:"string",
          //   name: "",
          //   detail: "",
          //   subDetail: [
          //     {heading:"",
          //       detail:""
          //     },
          //     {heading:"",
          //       detail:""
          //     }, 
          //     {heading:"",
          //       detail:""
          //     }, 
          //   ],
          // }
        ]
    },
    

    {
      id: "oltc-transformer",
      image: OLTC_transformer,
      name: "Transformer with On-Load Tap Changer (OLTC)",
      detail: "A Transformer with On-Load Tap Changer (OLTC) is designed to regulate voltage levels while the transformer is energized. It provides continuous voltage adjustment without interrupting the power supply, making it essential for maintaining system stability in various electrical applications.",
      subDetail: "OLTC transformers are widely used in power distribution systems where voltage levels need to be adjusted under load conditions, enhancing overall efficiency and performance.",
      additionalInfo: "",
      products: [
        {
          p1: "Core",
          brand: "", 
          p2:"The core is made from high-quality silicon steel to minimize energy losses and provide an efficient magnetic path.",
        },
        {
          p1: "Primary Winding",
          brand: "", 
          p2:"The primary winding connects to the input voltage source, generating a magnetic field for the transformer.",
        },
        {
          p1: "Secondary Winding",
          brand: "", 
          p2:"The secondary winding delivers the transformed voltage to the load, ensuring reliable power supply.",
        },
        {
          p1: "On-Load Tap Changer (OLTC)",
          brand: "", 
          p2:"The OLTC allows for voltage regulation without interrupting the power supply, enabling seamless adjustments while the transformer is energized.",
        },
        {
          p1: "Insulation",
          brand: "", 
          p2:"Insulation materials are used to prevent electrical short circuits and ensure safe operation.",
        },
        {
          p1: "Cooling System",
          brand: "", 
          p2:"Cooling systems, such as oil or air, dissipate heat generated during operation, maintaining efficiency.",
        },
        {
          p1: "Control Circuit",
          brand: "", 
          p2:"The control circuit monitors and manages the operation of the OLTC, allowing for accurate voltage adjustments.",
        }
      ],
      purchaseReason:
        "Investing in our Transformer with On-Load Tap Changer ensures optimal voltage regulation and enhanced system stability. Built with premium components from trusted brands like Siemens, Havells, and Schneider, our transformers deliver reliable performance in dynamic load conditions. We provide customizable solutions tailored to your specific voltage and power requirements, making them ideal for a range of industrial and commercial applications. Our expert team is committed to offering exceptional support and guidance, ensuring you choose the right transformer for your needs. Choose our OLTC transformer for a dependable and efficient power management solution.",
    },

    {
      id: "lt-panels",
      image: LT_Pannel,
      name: "Low Tension (LT) Panels",
      detail: "Low Tension (LT) Panels are electrical distribution boards that receive electrical power from generators or transformers and distribute it to various electrical devices and distribution boards within a facility. These panels operate at a low voltage level, typically up to 1,000 volts, and are an integral part of electrical power distribution in residential, commercial, and industrial settings.",
      subDetail: "Low Tension Panels are essential components of electrical distribution systems, providing safe and efficient power distribution for various applications. Their versatility, safety features, and ability to handle low voltage requirements make them indispensable in residential, commercial, and industrial settings. By customizing LT panels to specific needs, facilities can ensure optimal power management, protection, and operational efficiency.",
      additionalInfo: "",
      products: [
          {   
              p1: "Voltmeter",
              brand: "Procom, Nippen",
              p2: "Used for monitoring the voltage levels across the system, our voltmeters are precise and reliable, providing real-time feedback to ensure smooth operation."
          },
          {
              p1: "Ammeter",
              brand: "Procom, Nippen",
              p2: "Our ammeters help you monitor the current flowing through the system, preventing overloads and ensuring your electrical setup remains within safe operating parameters."
          },
          {
              p1: "Miniature Circuit Breaker (MCB)",
              brand: "Karloskar, Schneider",
              p2: "We use high-performance MCBs that provide protection from overcurrent, short circuits, and other electrical faults, ensuring the safety of your system."
          },
          {
              p1: "Wiring and Cabling",
              brand: "Havells, RR Kabel",
              p2: "Our VCBs use industry-standard wiring and cabling from trusted suppliers, ensuring that all connections are reliable, durable, and suitable for high-voltage applications."
          },
          {
              p1: "Control Switches and Panels",
              brand: "Havells",
              p2: "Our control panels are designed for ease of use, with intuitive control switches to operate the VCB seamlessly."
          },
          {
              p1: "Indicators",
              brand: "Nippen, JIGO",
              p2: "Our indicators provide clear, real-time visual status of the system’s operational state, enhancing monitoring and safety.",
            },
            {
              p1: "Trip Normal Close Switch",
              brand: "Elante",
              p2: "This switch facilitates the manual or automatic trip and close operations, essential for the effective control of circuit interruption and restoration.",
            },
      ],
      purchaseReason:"",
      variantData: [

        { image:pcc,
          name: "Power Control Center (PCC)",
          detail: "A Power Control Center (PCC) is an electrical panel designed to distribute power efficiently across industrial or commercial applications. It serves as a centralized control hub, ensuring safe and reliable power management for connected equipment. PCCs are essential for industries where uninterrupted and controlled power distribution is critical.",
          subDetail: [
            {heading:"Rated Voltage",
              detail:"Operates at 415V AC for low voltage systems and up to 33kV for medium voltage applications."
            },
            {heading:"Rated Current",
              detail:"Handles currents up to 6300A, depending on the configuration and load requirements."
            }, 
            {heading:"Bus Bar Material",
              detail:"Made of electrolytic-grade copper or aluminum, ensuring high conductivity and minimal energy loss."
            }, 
            {heading:"Circuit Breakers",
              detail:"Equipped with Air Circuit Breakers (ACBs) or Molded Case Circuit Breakers (MCCBs) for safe and effective circuit control."
            },
            {heading:"Metering and Monitoring",
              detail:"Includes digital meters for voltage, current, power factor, and energy consumption, with optional integration for SCADA/PLC systems."
            },
            {heading:"Cooling System",
              detail:"Designed with ventilation and optional fan cooling to prevent overheating."
            },
          ],
        },

        { image:mcc,
          name: "Motor Control Center (MCC)",
          detail: "A Motor Control Center (MCC) is an electrical panel used to manage, monitor, and protect motors in industrial and commercial settings. It provides centralized control for multiple motors, improving efficiency, safety, and ease of operation. MCCs are essential in facilities where numerous motors operate simultaneously, such as manufacturing plants and utility stations.",
          subDetail: [
            {heading:"Rated Voltage",
              detail:"Designed for 415V to 690V AC, suitable for low and medium-voltage systems."
            },
            {heading:"Rated Current",
              detail:"Handles motor currents from 10A to 4000A, depending on the application."
            }, 
            {heading:"Motor Starter Types",
              detail:"Direct On-Line (DOL) for small motors, Star-Delta for high-capacity motors, Variable Frequency Drives (VFDs) for speed and torque control, Soft Starters for smooth motor starts."
            }, 
            {heading:"Bus Bars",
              detail:"Made of electrolytic-grade copper or aluminum, ensuring low power losses and high conductivity."
            },
            {heading:"Control Features",
              detail:"Equipped with push buttons, indicator lights, and digital meters for monitoring voltage, current, and power consumption."
            },
            {heading:"Integration Capability",
              detail:"Can be integrated with PLCs and SCADA systems for remote monitoring and automation."
            },
          ],
        },

        { image: pfc,
          name: "Power Factor Control",
          detail: "Power Factor Control (PFC) systems are designed to improve the power factor of electrical networks. Power factor measures how efficiently electrical power is converted into useful work output. A poor power factor can lead to higher energy losses and increased electricity costs. PFC systems help optimize energy usage, reduce losses, and prevent penalties from utility companies.",
          subDetail: [
            {heading:"Rated Voltage",
              detail:"Typically operates at 415V AC or higher for industrial systems."
            },
            {heading:"Power Factor Range",
              detail:"Improves power factor to 0.95 or above, depending on the system design."
            }, 
            {heading:"Controller Type",
              detail:"Advanced Automatic Power Factor Controllers (APFC) monitor and adjust power factor in real-time."
            }, 
            {heading:"Switching Mechanism",
              detail:"Uses Electromechanical Relays or Thyristor-based Switching for fast and reliable capacitor bank operation."
            },
             {heading:"Harmonic Filters",
              detail:"Optional filters are integrated to reduce harmonic distortion and improve system efficiency."
            }, 
            {heading:"Indicators and Displays",
              detail:"Digital displays for monitoring voltage, current, power factor, and capacitor bank status."
            }, 
          ],
        }



        
       ]
    },

    {
    id: "vacuum-circuit-breaker",
    image: vcd,
    name: "Vacuum Circuit Breaker (VCB)",
    detail: "A Vacuum Circuit Breaker (VCB) is a type of circuit breaker that uses vacuum as the arc-quenching medium to interrupt electrical current during fault conditions (such as short circuits or overloads). VCBs are widely used in medium-voltage applications, typically in the range of 11 kV to 35 kV. They are known for their reliable performance, long life, and minimal maintenance requirements.",
    subDetail: "In a VCB, this arc is extinguished in a vacuum chamber. The vacuum has a high dielectric strength, meaning it can withstand high voltages without breaking down, which makes it very effective at interrupting arcs.",
    additionalInfo: "In our product, we use Vacuum Circuit Breakers (VCBs) from trusted brands such as ABB, Kirloskar, Schneider, Siemens, Crompton and Jyoti Limited Manufactures. These companies are renowned for their cutting-edge technology and reliable VCBs, providing the highest level of safety and performance in medium-voltage applications. Their products meet international standards, ensuring durability and minimal maintenance over long operational periods.",
    products: [
        {   
            p1: "Voltmeter",
            brand: "Procom, Nippen",
            p2: "Used for monitoring the voltage levels across the system, our voltmeters are precise and reliable, providing real-time feedback to ensure smooth operation."
        },
        {
            p1: "Ammeter",
            brand: "Procom, Nippen",
            p2: "Our ammeters help you monitor the current flowing through the system, preventing overloads and ensuring your electrical setup remains within safe operating parameters."
        },
        {
            p1: "Miniature Circuit Breaker (MCB)",
            brand: "Havells, Schneider",
            p2: "We use high-performance MCBs that provide protection from overcurrent, short circuits, and other electrical faults, ensuring the safety of your system."
        },
        {
            p1: "Wiring and Cabling",
            brand: "Havells, RR Kabel",
            p2: "Our VCBs use industry-standard wiring and cabling from trusted suppliers, ensuring that all connections are reliable, durable, and suitable for high-voltage applications."
        },
        {
            p1: "Auxiliary Relays",
            brand: "Ashida",
            p2: "High-quality relays used for protection and automation in electrical circuits, contributing to the safety and efficiency of the VCB system."
        },
        {
            p1: "Control Switches and Panels",
            brand: "Havells",
            p2: "Our control panels are designed for ease of use, with intuitive control switches to operate the VCB seamlessly."
        },
        {
            p1: "Indicators",
            brand: "Nippen, JIGO",
            p2: "Our indicators provide clear, real-time visual status of the system’s operational state, enhancing monitoring and safety.",
          },
          {
            p1: "Master Relay",
            brand: "Areva",
            p2: "The master relay coordinates the control and protection functions, ensuring smooth and safe operation of the entire VCB system.",
          },
          {
            p1: "Trip Normal Close Switch",
            brand: "Elante",
            p2: "This switch facilitates the manual or automatic trip and close operations, essential for the effective control of circuit interruption and restoration.",
          },
    ],
    purchaseReason:
    "By purchasing our VCBs, you are guaranteed a high-quality, reliable product backed by extensive industry experience. We provide tailored solutions to meet your unique requirements, including full customization options to ensure the VCB fits seamlessly into your electrical system. Additionally, we offer second-hand VCBs for those seeking cost-effective alternatives without compromising on quality. Our expert team is ready to assist you in selecting the right product for your needs, making us a trusted partner in your power solutions."

    },

    {
  id: "air-circuit-breaker",
  image: ACB,
  name: "Air Circuit Breaker (ACB)",
  detail: "An Air Circuit Breaker (ACB) is a crucial component used to protect transformers and associated electrical circuits from faults such as overcurrent, short circuits, and electrical overloads. While an ACB itself is not a transformer, it is often used in conjunction with transformers to ensure the safe and reliable operation of electrical systems.",
  subDetail: "In an ACB, the arc is extinguished using high-pressure air or air-blast techniques, making it effective for low and medium-voltage systems. ACBs provide both protection and control in electrical circuits, contributing to the overall safety of the installation.",
  additionalInfo: "",
  products: [
      {   
          p1: "Arc Chutes",
          brand: "",
          p2: "Arc chutes help in cooling and splitting the arc during interruption, making it easier for the breaker to safely extinguish the arc."
      },
      {
          p1: "Trip Unit",
          brand: "",
          p2: "The trip unit is responsible for detecting electrical faults and triggering the breaker to open and stop the flow of electricity."
      },
      {
          p1: "Main Contacts",
          brand: "",
          p2: "Main contacts are the points through which the current passes during normal operation. They are designed to withstand high electrical currents."
      },
      {
          p1: "Auxiliary Contacts",
          brand: "",
          p2: "Auxiliary contacts are secondary switching devices that operate alongside the main contacts for control and signaling purposes."
      },
      {
          p1: "Insulated Barriers",
          brand: "",
          p2: "Insulated barriers provide isolation between different sections of the breaker to prevent unwanted current paths and enhance safety."
      },
      {
          p1: "Closing Coil",
          brand: "",
          p2: "The closing coil is an electromagnetic device that helps close the circuit breaker when a command is given.",
        },
        {
          p1: "Air Blast Mechanism",
          brand: "",
          p2: "The air blast mechanism uses high-pressure air to quickly blow out the arc, making the breaker safe to handle large currents.",
        },
        {
          p1: "Electronic Control Module",
          brand: "",
          p2: "The electronic control module ensures proper operation, control, and monitoring of the ACB, often providing advanced communication capabilities.",
        }
  ],
  purchaseReason:"Choosing our Air Circuit Breaker means investing in safety and reliability. Our ACBs are designed with the highest quality standards and are built using components from trusted brands like Schneider, Siemens, and ABB. We offer customizable solutions tailored to your specific requirements, ensuring optimal performance for your electrical systems. Our team of experts is dedicated to providing exceptional customer service and technical support, helping you select the right product for your needs. With our commitment to quality and innovation, you can trust that our ACBs will deliver outstanding performance and peace of mind for your industrial or commercial applications."
    },
          
    {
      id: "servo-voltage-stabilizer",
      image: Servo,
      name: "Servo Voltage Stabilizer",
      detail: "A Servo Voltage Stabilizer is an electronic device designed to maintain a constant output voltage level despite variations in input voltage. It is crucial for protecting sensitive electrical equipment from voltage fluctuations, ensuring smooth operation and longevity.",
      subDetail: "Servo voltage stabilizers automatically adjust the output voltage in response to changing input conditions, making them essential for various applications, including industrial machinery, medical equipment, and home appliances.",
      additionalInfo: "",
      products: [
        {
          p1: "Servo Motor",
          brand: "", 
          p2:"The servo motor adjusts the output voltage by controlling the position of the variable transformer.",
        },
        {
          p1: "Control Circuit",
          brand: "", 
          p2:"The control circuit monitors input voltage levels and adjusts the servo motor accordingly to maintain the desired output.",
        },
        {
          p1: "Transformer",
          brand: "", 
          p2:"The transformer steps up or steps down the voltage as required to stabilize the output.",
        },
        {
          p1: "Display Unit",
          brand: "", 
          p2:"The display unit provides real-time information about input and output voltage levels for monitoring purposes.",
        },
        {
          p1: "Bypass Switch",
          brand: "", 
          p2:"The bypass switch allows the stabilizer to be disconnected from the circuit during maintenance or in case of failure.",
        },
        {
          p1: "Overload Protection",
          brand: "", 
          p2:"Overload protection safeguards the stabilizer and connected equipment from excessive current and potential damage.",
        },
        
      ],
      purchaseReason:
        "Investing in our Servo Voltage Stabilizer ensures your equipment is protected from voltage fluctuations, enhancing reliability and performance. Built with high-quality components from trusted brands like Havells, Siemens, and Schneider, our stabilizers deliver optimal voltage regulation for a wide range of applications. We offer customization options to meet your specific needs, making our stabilizers suitable for both industrial and residential use. Our expert team is ready to assist you in selecting the right stabilizer to enhance the efficiency and longevity of your electrical systems."
    },

    {
        id: "rectifier",
        image: rectifier,
        name: "Rectifier",
        detail: "A Rectifier is an electronic device that converts alternating current (AC) to direct current (DC). It plays a crucial role in power supply systems, ensuring that electrical devices receive the correct form of current for efficient operation.",
        subDetail: "Rectifiers can be classified into different types such as half-wave and full-wave rectifiers, and are widely used in power supplies, battery chargers, and in various industrial applications.",
        additionalInfo: "",
        products: [
          {
            p1: "Transformer",
            brand: "", 
            p2:"A transformer is used to step down or step up the voltage before it enters the rectification stage.",
          },
          {
            p1: "Diodes",
            brand: "", 
            p2:"Diodes are semiconductor devices that allow current to flow in one direction only, effectively converting AC to DC.",
          },
          {
            p1: "Filter Circuit",
            brand: "", 
            p2:"The filter circuit smoothens the output of the rectifier by reducing ripple voltage, providing a more stable DC output.",
          },
          {
            p1: "Voltage Regulator",
            brand: "", 
            p2:"Voltage regulators ensure a constant output voltage despite variations in load current and input voltage.",
          },
          {
            p1: "Control Circuit",
            brand: "",
            p2:"The control circuit manages the operation of the rectifier, allowing for adjustments and protections against overloads.",
          },
          {
            p1: "Heat Sink",
            brand: "", 
            p2:"Heat sinks are used to dissipate heat generated during the rectification process, enhancing the longevity of the device.",
          },
        ],
        purchaseReason:
          "Choosing our Rectifier ensures reliable performance and quality assurance. Designed with components from leading brands like Havells, Schneider, and Siemens, our rectifiers deliver optimal efficiency and durability. We offer customization options to fit your specific needs, ensuring that our products cater to a variety of industrial applications. Our expert team provides unparalleled support and guidance, ensuring you select the right rectifier for your requirements. Invest in our rectifiers for a robust and efficient solution to your power conversion needs."
    },
  
]






// {
//   id: "t",
//   image: ACB,
//   name: "",
//   detail: "",
//   subDetail: "",
//   additionalInfo: "",
//   products: [
//     {
//       p1: "",
//       brand: "", 
//       p2:"",
//     },
    
//   ],
//   purchaseReason:
//     ""
// }